import fetchWithTimeout from "../tools/fetchWithTimeout";
import { GetAPI } from "../tools/GetAPI";

export const GETTING_ORDERS = "GETTING_ORDERS";
export const GETTING_ORDERS_SUCCESS = "GETTING_ORDERS_SUCCESS";
export const GETTING_ORDERS_FAILURE = "GETTING_ORDERS_FAILURE";
export const ACKING_PAYMENT = "ACKING_PAYMENT";
export const ACKING_SHIPPING = "ACKING_SHIPPING";

const gettingOrders = () => ({
  type: GETTING_ORDERS,
});

const gettingOrdersSuccess = (orders) => ({
  type: GETTING_ORDERS_SUCCESS,
  orders: orders,
});

const gettingOrdersFailure = () => ({
  type: GETTING_ORDERS_FAILURE,
  orders: [],
});

const ackingShipping = (orders) => ({
  type: ACKING_SHIPPING,
  orders: orders,
});

const ackingPayment = (orders) => ({
  type: ACKING_PAYMENT,
  orders: orders,
});

export const getOrders = () => (dispatch) => {
  dispatch(gettingOrders());

  const URI = `${GetAPI()}/orders`;
  fetchWithTimeout(URI, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      if (!res.ok) throw new Error(res.statusText);
      return res.json();
    })
    .then((res) => {
      dispatch(gettingOrdersSuccess(res.orders));
    })
    .catch((err) => {
      dispatch(gettingOrdersFailure(err));
    });
};

export const ackPayment = (orderId) => (dispatch, getState) => {
  let state = getState();

  let updatedOrders = state.orders.map((order) => {
    let updatedOrder = Object.assign({}, order);
    if (updatedOrder.id === orderId) {
      updatedOrder.status = "paid";
    }
    return updatedOrder;
  });

  dispatch(ackingPayment(updatedOrders));
};

export const ackShipping = (orderId) => (dispatch, getState) => {
  let state = getState();

  let updatedOrders = state.orders.map((order) => {
    let updatedOrder = Object.assign({}, order);
    if (updatedOrder.id === orderId) {
      updatedOrder.status = "shipped";
    }
    return updatedOrder;
  });

  dispatch(ackingShipping(updatedOrders));
};



// WEBPACK FOOTER //
// ./src/redux/actions.js